import React from "react";
import compose from "lodash/flowRight";
import {connect} from "react-redux";
import get from "lodash/get";

function withMessenger(WrappedComponent) {
    const withMessengerContainer = (props) => <WrappedComponent {...props} />;
    const mapStateToProps = (state) => ({
        messengerState: state.messengerState,
        connectionState: get(state, "messengerState.connectionState", null),
        pusher: get(state, "messengerState.pusher", null),
    });
    return compose(connect(mapStateToProps))(withMessengerContainer);
}

export default withMessenger;
